// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R3k5dca1Wn444aBTwgzq{height:auto;min-height:32px}.TaLX_XkdcYcJ_RdqrSaJ{white-space:nowrap}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/developer/ui/DeveloperDocsSelect/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA,CACA,eAAA,CAGF,sBACE,kBAAA","sourcesContent":[".docItemOptionRow {\n  height: auto;\n  min-height: 32px;\n}\n\n.docItemOption {\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"docItemOptionRow": `R3k5dca1Wn444aBTwgzq`,
	"docItemOption": `TaLX_XkdcYcJ_RdqrSaJ`
};
export default ___CSS_LOADER_EXPORT___;
